import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';
import PropTypes from 'prop-types';

export default function LimitItem({ src, title, description, loading }) {
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  return (
    <Stack
      alignItems="start"
      direction="row"
      gap={{ xs: '12px', md: '24px' }}
    >
      <Stack
        alignItems="center"
        height={{ xs: 40, md: 48 }}
        justifyContent="center"
        minWidth={{ xs: 40, md: 48 }}
        sx={(theme) => ({
          borderRadius: '8px',
          backgroundColor: theme.palette.background.green.light
        })}
      >
        <SharedAsset
          alt=""
          color="primary"
          src={src}
          width={isMobile ? 20 : 25}
        />
      </Stack>
      <Stack
        gap={{ xs: 0, md: '4px' }}
        width="100%"
      >
        <Text
          color="primary"
          family="primary"
          size="md"
          weight="medium"
        >
          {title}
        </Text>
        <Text
          color="secondary"
          size="md"
          sx={{ width: '100%' }}
        >
          {loading ? <Skeleton width="100%" /> : description}
        </Text>
      </Stack>
    </Stack>
  );
}

LimitItem.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  loading: PropTypes.bool
};
